<template>
    <!-- qq，微信登录弹窗[[ -->
	<div class="g-popup g-popup-transparent js-login-popup" v-show="show">
	    <div class="popup-con login-popup-con">
	        <div class="popup-close js-close-view" v-if="closeBtn" @click="close"><i class="ico ico-close"></i></div>
	        <h5 class="popup-title">
	        	<img src="~Assets/img/pages/v4/tgl-login-logo.png" >
	        </h5>
	        <p class="confim-content">
	        	<em class="confim-content-line"></em>
	        	<span class="confim-content-text">选择您的登录方式</span>
	        	<em class="confim-content-line"></em>
	        </p>
	        <div class="login-btn">
	        	<a v-if="!disableType.includes('qq')" class="qq-login-btn f-inlineblock-top" href="javascript:;" @click="showQQmodel">
	        		<span class="ico ico-qq"></span>
	        		<p class="login-btn-con">QQ登录</p>
	        	</a>
	        	<a v-if="!disableType.includes('wx')" class="weixin-login-btn f-inlineblock-top" href="javascript:;" @click="showWXmodel">
	        		<span class="ico ico-weixin"></span>
	        		<p class="login-btn-con">微信登录</p>
	        	</a>
	        </div>
	    </div>
        <div class="popup-con login-popup-con" id="login-pop" v-show="isLogin">
            <!-- style="display:block;width:1000px;height: 580px;margin: 60px auto 0;" -->
            <div class="popup-close js-close-view" @click="closeLoginPop"><i class="ico ico-close"></i></div>
            <iframe :src="src" frameborder="0"  id="tgl-login__pop" width="622" height="600"  scrolling="no"></iframe>
        </div>
	</div>
    <!-- qq，微信登录弹窗]] -->
</template>
<style lang='scss' scoped>
    #login-pop{
        width: 622px;
        height: 605px;
        padding-top: 55px;
    }
</style>

<script>
import {
    QQLogin, WXLogin 
} from 'Services/getData.js';
export default {
    props: {
        closeBtn: {
		        type: Boolean,
		        // 对象或数组默认值必须从一个工厂函数获取
		        default: false
        },
        disableType: {
            type: Array,
            default: function () {
                return [];
            }
        }
    },
    data(){
        return{
            showModel: false,
            showWx: false,
            show: false,
            showWxTest: false,
            src: '',
            isLogin: false
        }
    },
    mounted() {
        if(!this.$store.state.status.login && this.$route.meta.needLogin !== false && !this.$store.state.banInfo.isBan){
            this.show = true;
        }
        window.loginSuccess = () =>{
            this.isLogin = false;
            this.show = false;
            this.$store.dispatch({
                type: 'getUserInfo'
            });
            location.reload();
            // this.realUserInfo
        }
        window.loginFailure = (message)=>{
            this.isLogin = false;
            alert(message);
        }
    },
    methods: {
        closeLoginPop(){
            this.isLogin = false;
        },
        async showQQmodel(){
            this.src = '';
            let res = await QQLogin();
            this.src = res.data.data.url;
            this.isLogin = true;
            console.log(res)
        },
        async showWXmodel(){
            this.src = '';
            let res = await WXLogin();
            this.src = res.data.data.url;
            this.isLogin = true;
            console.log(res)
        },
        close(){
            this.show = false;
        }
    }
}
</script>